module.exports = __webpack_public_path__ + "img/20190731162158793.723772ab.png";